<template>
  <div>
    <mdb-row>
      <mdb-col md="4" class="my-2" v-for="(t, i) in trainings" :key="i">
        <training-card :training="t" class="pointer" @select-training="onSelectTraining"/>
      </mdb-col>
    </mdb-row>
    <subject-summary v-if="selectTraining" :training="selectTraining"/>
  </div>
</template>
<script>
import { } from 'mdbvue';
import Training from '@/models/Training';
import TrainingCard from './TrainingCard.vue';
import SubjectSummary from '@/components/subject/SubjectSummary.vue';
export default {
  name: 'TrainingCardList',
  components: { TrainingCard, SubjectSummary },
  props: ['org'],
  data: () => ({
    trainings: [],
    selectTraining: undefined
  }),
  methods: {
    async load () {
      if (!this.org) return
      const org = this.org
      this.trainings = await Training.cardList({ org })
    },
    async onSelectTraining (training) {
      this.selectTraining = training
    }
  },
  async created () {
    this.load()
  },
  watch: {
    org: 'load'
  }
}
</script>
